import { render, staticRenderFns } from "./MainPagePanel2.vue?vue&type=template&id=3adf7ba0&scoped=true&"
import script from "./MainPagePanel2.vue?vue&type=script&lang=js&"
export * from "./MainPagePanel2.vue?vue&type=script&lang=js&"
import style0 from "./MainPagePanel2.vue?vue&type=style&index=0&id=3adf7ba0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3adf7ba0",
  null
  
)

export default component.exports